import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProgressReportDetails from "./routes/ProgressReportDetails";
export default store => ({
  path: "progressreport",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-progressreport" */ "./components"),
        import(
          /* webpackChunkName: "course-progressreport" */ "./modules/ProgressReportModule"
        ),
        import(
          /* webpackChunkName: "course-progressreport" */ "AdminProgressReports/modules/AdminProgressReportsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const adminProgressReportReducer = importedModule2.default;
        injectReducer(store, {
          key: "progressReport",
          reducer,
        });
        injectReducer(store, {
          key: "adminProgressReport",
          reducer: adminProgressReportReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ProgressReportDetails(store)],
});
